export const GoogleIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='currentColor'>
			<path
				d='M19.99 10.187c0-.82-.069-1.412-.216-2.03H10.2v3.686h5.482c-.11.958-.717 2.406-2.06 3.373l-.02.124 2.988 2.33.207.02c1.9-1.762 2.995-4.358 2.995-7.443z'
				fill='#4285F4'
			/>
			<path
				d='M10.2 20c2.715 0 4.996-.896 6.662-2.446l-3.19-2.492c-.854.594-1.995 1.004-3.472 1.004-2.665 0-4.926-1.762-5.732-4.213l-.117.01L.885 16.14l-.04.132c1.656 3.3 5.035 5.728 9.355 5.728z'
				fill='#34A853'
			/>
			<path
				d='M4.468 11.853c-.214-.637-.336-1.316-.336-2.018s.122-1.381.336-2.018L4.468 7.76 1.398 5.497l-.14.067C.496 6.678 0 8.283 0 10s.496 3.322 1.258 4.436l3.21-2.65z'
				fill='#FBBC05'
			/>
			<path
				d='M10.2 4.025c1.892 0 3.17.82 3.899 1.506l2.845-2.794C15.187 1.075 12.915 0 10.2 0 5.88 0 2.5 2.428 1.258 5.728l3.21 2.65c.806-2.45 3.067-4.353 5.732-4.353z'
				fill='#EB4335'
			/>
		</svg>
	)
}

export const InstagramIcon = () => {
	return (
		<svg
			width='30px'
			height='30px'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			stroke='#000000'
			stroke-width='0.00024000000000000003'
		>
			<g id='SVGRepo_bgCarrier' stroke-width='0'></g>
			<g
				id='SVGRepo_tracerCarrier'
				stroke-linecap='round'
				stroke-linejoin='round'
			></g>
			<g id='SVGRepo_iconCarrier'>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z'
					fill='#0F0F0F'
				></path>
				<path
					d='M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z'
					fill='#0F0F0F'
				></path>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z'
					fill='#0F0F0F'
				></path>
			</g>
		</svg>
	)
}
